import isEmail from 'validator/es/lib/isEmail';

export function validateEmail(email: string) {
  if (email.length === 0) {
    return {valid: false, error: 'Email is required'};
  }
  if (!isEmail(email)) {
    return {valid: false, error: 'Invalid email address'};
  }
  return {valid: true, error: null};
}
